import { EventModel } from 'api/model';
import React, { FC } from 'react';
import { EventSection, Message } from './components';
import DefaultEventHeader from './DefaultEventHeader';

interface Props {
  event: EventModel;
  title: string;
  icon?: React.ReactNode;
}

const TitledEvent: FC<Props> = ({ event, title, icon }) => {
  return (
    <EventSection>
      <DefaultEventHeader
        position={event.position}
        created={event.created}
        headerText={
          <>
            {icon} {title}
          </>
        }
        modified={event.modified}
        modifiedByID={event.modifiedByID}
        createdByID={event.createdByID}
        userName={event.createdBy}
      />

      <Message>{event.message}</Message>
    </EventSection>
  );
};

export default TitledEvent;
